import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const stages = [{
    num: '1️⃣',
    title: 'Comprensión mental del futbolista adolescente',
    desc: 'Entendés qué ocurre en su mente durante entrenamientos y competencia.'
  }, {
    num: '2️⃣',
    title: 'Comunicación estratégica',
    desc: 'Aprendés qué decir antes, durante y después de cada partido.'
  }, {
    num: '3️⃣',
    title: 'Refuerzo emocional progresivo',
    desc: 'Construís confianza real y resiliencia competitiva.'
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <div className="text-center mb-12" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-black text-green-700 mb-2 uppercase" data-id="element-182">
            ✅ LA SOLUCIÓN
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 uppercase" data-id="element-183">
            ACOMPAÑAMIENTO EMOCIONAL ESTRATÉGICO
          </h3>
        </div>

        {/* Product Reveal */}
        <div className="text-center bg-gray-900 text-white p-8 md:p-12 rounded-3xl shadow-2xl relative overflow-hidden mb-16" data-id="element-184">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-400 to-blue-500" data-id="element-185"></div>
          <h2 className="text-3xl md:text-5xl font-black mb-4 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300" data-id="element-186">
            MEGAPACK MENTALIDAD FÚTBOL
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-2xl mx-auto" data-id="element-187">
            Un sistema paso a paso para que sepas exactamente cómo acompañarlo
            en cada etapa.
          </p>
          <p className="text-lg text-gray-400 mb-8 max-w-xl mx-auto" data-id="element-188">
            No es motivación vacía. No es teoría.
            <br data-id="element-189" />
            <span className="text-white font-bold" data-id="element-190">
              Es intervención práctica para padres.
            </span>
          </p>
          <a href="#precio" className="inline-block bg-green-500 hover:bg-green-600 text-white text-xl font-bold py-4 px-10 rounded-full shadow-lg transform transition hover:scale-105" data-id="element-191">
            👉 QUIERO ACCEDER AL PROGRAMA
          </a>
        </div>

        {/* Cómo Funciona */}
        <div className="mb-8" data-id="element-192">
          <div className="text-center mb-10" data-id="element-193">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 uppercase" data-id="element-194">
              ⚙️ CÓMO FUNCIONA EL SISTEMA
            </h3>
            <p className="text-gray-600 mt-2" data-id="element-195">
              El programa trabaja en 3 etapas progresivas:
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-196">
            {stages.map((stage, i) => <div key={i} className="bg-gray-50 p-6 rounded-2xl border border-gray-200 text-center" data-id="element-197">
                <div className="text-4xl mb-4" data-id="element-198">{stage.num}</div>
                <h4 className="font-bold text-lg text-gray-900 mb-3" data-id="element-199">
                  {stage.title}
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-200">{stage.desc}</p>
              </div>)}
          </div>

          <p className="text-center mt-8 text-gray-700 font-medium" data-id="element-201">
            Resultados visibles en pocas semanas cuando se aplica correctamente.
          </p>
        </div>

        {/* Sobre el Programa */}
        <div className="mt-16 bg-gradient-to-br from-green-600 to-green-800 p-8 md:p-10 rounded-2xl text-center shadow-xl" data-id="element-202">
          <h3 className="text-2xl font-black text-white mb-4 uppercase" data-id="element-203">
            SOBRE EL PROGRAMA
          </h3>
          <div className="max-w-3xl mx-auto space-y-4 text-green-50 text-lg" data-id="element-204">
            <p data-id="element-205">
              Este programa integra principios de{' '}
              <span className="font-bold text-white" data-id="element-206">
                psicología deportiva juvenil
              </span>
              , acompañamiento emocional adolescente y estrategias utilizadas en
              formación competitiva.
            </p>
            <p data-id="element-207">
              El contenido fue desarrollado a partir del estudio del
              comportamiento de futbolistas juveniles bajo presión competitiva y
              necesidades reales de familias deportivas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}